<div *ngFor="let message of messages; let i = index">
  <div
    class="message"
    id="i"
    [class.info]="message.type === 'info'"
    [class.warning]="message.type === 'warning'"
    [class.success]="message.type === 'success'"
    [class.error]="message.type === 'error'"
    (click)="handleOnClickMessage(i)"
  >
    <tui-svg
      src="tuiIconInfo"
      class="icon"
      *ngIf="message.type === 'info'"
    ></tui-svg>
    <tui-svg
      src="tuiIconAlertTriangle"
      class="icon"
      *ngIf="message.type === 'warning'"
    ></tui-svg>
    <tui-svg
      src="tuiIconCheckCircle"
      class="icon"
      *ngIf="message.type === 'success'"
    ></tui-svg>
    <tui-svg
      src="tuiIconXCircle"
      class="icon"
      *ngIf="message.type === 'error'"
    ></tui-svg>
    {{ message.message }}
  </div>
</div>
